import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Dashboard from './Dashboard';
import Architecture from './Architecture';
import Facts from './Facts';
import GettingStarted from './Getting-Started';
import PlantsView from './Plants-View';
import Plants from './Plants';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { signIn } from 'aws-amplify/auth'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
        <Route index element={<Dashboard />} />
        <Route path="plantsview" element={<Plants />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="gettingstarted" element={<GettingStarted />} />
        <Route path="facts" element={<Facts />} />
        <Route path="architecture" element={<Architecture />} />
        {/* <Route path="*" element={<NoPage />} /> */}
    </Routes>
  </BrowserRouter>
);